module.exports={"en-US":{office_location:"Office Location",your_ip:"Your IP",yes:"Yes",no:"No",not_configured:"Not Configured",cancel:"Cancel"}};